function splitText(el) {
	const originalText = el.textContent
	el.innerHTML = ''
	Array.from(originalText).forEach((char, i) => {
		const span = document.createElement('span')
		span.classList.add('letters')
		span.setAttribute('aria-hidden', 'true')
		span.textContent = char === ' ' ? '\u00A0' : char
		span.style.transitionDelay = `${i * 0.035}s`
		el.appendChild(span)
	})
	el.setAttribute('aria-label', originalText)
}

function mainAnimate() {
	const script = document.querySelector('[data-animate-parent-node]')
	if (!script) {
		console.warn('<script> with with attribute [data-animate-parent-node] not found.')
		return
	}

	if (script.defer || script.async) {
		console.warn('Warning: the <script> tag must not include async or defer attributes.', script)
		return
	}

	const targetNode = document.querySelector(script.dataset.animateParentNode)
	if (!targetNode) return

	targetNode.classList.add('animate-initialized')

	const elementSelector = '[data-animate],.underline-highlight'

	const textSelector = '.text-label'

	const combinedSelector = elementSelector + ',' + textSelector

	const intersectionObserver = new IntersectionObserver(
		entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add('animate-intersected')
					intersectionObserver.unobserve(entry.target)
				}
			})
		},
		{
			rootMargin: '-50px',
		}
	)

	const mutationObserver = new MutationObserver(mutations => {
		mutations.forEach(mutation => {
			mutation.addedNodes.forEach(node => {
				if (node.nodeType === Node.ELEMENT_NODE && node.matches(combinedSelector)) {
					if (node.matches(textSelector)) {
						splitText(node)
					}
					intersectionObserver.observe(node)
				}
			})
		})
	})

	mutationObserver.observe(targetNode, {
		childList: true,
		subtree: true,
	})
}

mainAnimate()
